<script lang="ts">
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  import { navigateCustom } from "../utils/navigateCustom"
  import { Button, DataTable, Pager, FlexItem, Flex, Icon, Text, TextField, Form } from "@gl/design-system"
  import { _ } from "svelte-i18n"
  import { faPlus } from "@fortawesome/pro-regular-svg-icons"

  // pager
  export let totalCount = 0
  export let limit = 10
  export let offset = 0
  let currentPage = 0
  let pager = {}
  let pageInfo = {}

  let table;
  export let loading = true;
  export let data = []
  export let title = "Title"
  export let searchText: undefined | string
  export let newButton = {
    enabled: false,
    link: "",
    text: "New"
  }

  function handleSearch() {
    dispatch("search")
  }

  function resetFilter() {
    searchText = ""
    dispatch("search")
  }

  function handleShowChange() {
    dispatch("search")
  }

  function handlePageChange(e) {
    if (e.type === "next") currentPage++
    if (e.type === "previous") currentPage--
    if (e.type === "go") currentPage = Math.floor(e.detail / limit)

    pageInfo = { ...pageInfo, startRank: currentPage * limit + 1 }
    offset =  currentPage * limit
    dispatch("search")
  }
</script>

<Flex>
  <FlexItem>
    <h3 class="gl-title level-3">{title}</h3>
  </FlexItem>
  {#if newButton.enabled }
  <FlexItem pushEnd={true}>
    <Button on:click={(e) => navigateCustom(newButton.link, e)}>
      <Icon icon={faPlus} />
      <Text>{newButton.text}</Text>
    </Button>
  </FlexItem>
  {/if}
</Flex>
<p>
  {$_("common.found_total", {
    values: { total: totalCount },
  })}
</p>

{#if searchText != undefined }
<Form>
<Flex class="flex-wrap-wrap align-items-center mt-5">
  <FlexItem class="mt-2" style="width:300px">
    <TextField bind:value={searchText} variant="Search" />
  </FlexItem>

  <FlexItem>
    <Button type="submit" class="mt-2 ml-2 mr-2" on:click={handleSearch}>{$_("common.search")}</Button>
  </FlexItem>

  <FlexItem>
    <Button outlined class="mt-2" on:click={resetFilter}>{$_("common.reset")}</Button>
  </FlexItem>
</Flex>
</Form>
{/if}

<div class="table">
<DataTable
  bind:this={table}
  {data}
  {loading}
  {...$$restProps}
  let:index
  let:row
  on:change
  variant="separate"
  fullWidth
  selectable={false}>
  <slot {index} {row}/>
</DataTable>
</div>
<Flex class="mt-2">
  <FlexItem pushEnd>
    <div class="gl-select" style="width:170px">
      <select bind:value={limit} on:change={handleShowChange}>
        <option value={10}>{$_("common.show")}: 10</option>
        <option value={20}>{$_("common.show")}: 20</option>
        <option value={50}>{$_("common.show")}: 50</option>
        <option value={100}>{$_("common.show")}: 100</option>
        <option value={200}>{$_("common.show")}: 200</option>
      </select>
    </div>
  </FlexItem>
</Flex>

<div class="my-5">
  <Pager
    bind:this={pager}
    bind:pageInfo
    on:go={handlePageChange}
    on:previous={handlePageChange}
    on:next={(e) => handlePageChange(e)}
    totalCount={totalCount}
    perPage={limit}
    previousLabel={$_("common.previous")}
    nextLabel={$_("common.next")}
  />
</div>


<style>
  .table {
    margin: 1% auto;
    font-size: 16px;
  }

  .table :global(td) {
    padding: 12px;
    text-align: left;
  }

  .table :global(button) {
    white-space: nowrap;
    box-sizing: border-box;
  }
</style>